<template>
  <div style="margin-top: 50px">
    <!-- 带返回的标题栏 -->
    <mt-header title="工单详情">
      <router-link slot="left" to="">
        <mt-button @click="formReturn" icon="back">返回</mt-button>
      </router-link>
      <div slot="right">
        <mt-button class="m-1" @click="openDeletePicker">
          <img slot="icon" src="@/assets/del.png" width="24" height="24" />
        </mt-button>
        <mt-button class="m-1" @click="openPicker">
          <img slot="icon" src="@/assets/more.png" width="24" height="24" />
        </mt-button>
      </div>
    </mt-header>
    <!-- 工单信息 -->
    <scroll-body
      class="m-1"
      :minheight="200"
      :outheight="160"
      :isScroll="true"
      @resize="resize"
    >
      <template slot="content">
        <div>
          <mt-field label="工单标题" disabled v-model="data.pst.title" />
          <mt-field label="工单类别" disabled v-model="data.pstTypeName" />
          <mt-field label="发贴时间" disabled v-model="data.pst.postingTime" />
          <!-- <mt-field label="发贴人" disabled v-model="data.pst.name" /> -->
          <mt-field label="来源" disabled v-model="data.pst.pstSource" />
          <mt-field label="状态" disabled v-model="data.statusName" />
          <mt-field label="工单内容" disabled />
          <mt-field
            disabled
            type="textarea"
            rows="5"
            v-model="data.pst.pstContent"
          />
        </div>
        <!-- 负面舆情佐证 -->
        <div
          v-if="
            data.pst.status == -2 &&
            data.negativeNode &&
            data.negativeNode.uploadCount > 0
          "
        >
          <hr
            style="
              background-color: gray;
              height: 1px;
              border: none;
              margin: 0 5px;
            "
          />
          <el-card class="box-card">
            <upload :nodeId="data.negativeNode.id" :disabled="true" />
          </el-card>
        </div>
        <!-- 答复信息 -->
        <div v-if="data.replyNode">
          <el-divider content-position="left">
            <font color="gray">答复信息</font>
          </el-divider>
          <mt-field
            label="办理单位"
            disabled
            v-model="data.replyNode.unitName"
          />
          <mt-field label="答复内容" disabled />
          <mt-field
            disabled
            type="textarea"
            rows="6"
            v-model="data.replyNode.nodeMessage"
          />
          <el-card class="box-card" v-if="data.replyNode.uploadCount > 0">
            <upload :nodeId="data.replyNode.id" :disabled="true" />
          </el-card>
        </div>
      </template>
    </scroll-body>
    <!-- 菜单选择 -->
    <mt-actionsheet
      cancelText="取消"
      :closeOnClickModal="false"
      :actions="actionSheet.actions"
      v-model="actionSheet.sheetVisible"
    />
    <!-- 删除确认菜单选择 -->
    <mt-popup
      :closeOnClickModal="false"
      v-model="deletePopup.popupVisible"
      position="bottom"
      style="width: 100%"
    >
      <div>
        <mt-header title="警告">
          <mt-button slot="right" @click="deletePopup.popupVisible = false">
            <img slot="icon" src="@/assets/close.png" width="24" height="24" />
          </mt-button>
        </mt-header>
        <div class="d-flex ai-center jc-center fs-xl" style="height: 100px">
          <div>
            <img src="@/assets/warning.png" width="24" height="24" />
          </div>
          <div class="ml-2">确定要删除本工单吗？</div>
        </div>
        <hr
          style="
            background-color: gray;
            height: 1px;
            border: none;
            margin: 0 5px;
          "
        />
        <div class="d-flex jc-center mt-2">
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="deletePst"
            >确定</mt-button
          >
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="deletePopup.popupVisible = false"
            >取消</mt-button
          >
        </div>
        <div style="height: 10px"></div>
      </div>
    </mt-popup>
    <!-- 工单审查 -->
    <mt-popup
      :closeOnClickModal="false"
      v-model="pstAudit.popupVisible"
      position="bottom"
      style="width: 100%"
    >
      <div>
        <mt-header title="工单审查">
          <mt-button slot="right" @click="pstAudit.popupVisible = false">
            <img slot="icon" src="@/assets/close.png" width="24" height="24" />
          </mt-button>
        </mt-header>
        <div>
          <gdanaudit
            ref="gdanaudit"
            :pstId="data.pst.id"
            @success="gdanAuditSuccess"
          />
        </div>
        <hr
          style="
            background-color: gray;
            height: 1px;
            border: none;
            margin: 0 5px;
          "
        />
        <div class="d-flex jc-center mt-2">
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="gdanAudit"
            >确定</mt-button
          >
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="pstAudit.popupVisible = false"
            >取消</mt-button
          >
        </div>
        <div style="height: 10px"></div>
      </div>
    </mt-popup>
    <!-- 工单转办 -->
    <mt-popup
      :closeOnClickModal="false"
      v-model="pstTransfer.popupVisible"
      position="bottom"
      style="width: 100%"
    >
      <div>
        <mt-header title="工单转办">
          <mt-button slot="right" @click="pstTransfer.popupVisible = false">
            <img slot="icon" src="@/assets/close.png" width="24" height="24" />
          </mt-button>
        </mt-header>
        <div>
          <gdantransfer
            ref="gdantranser"
            :pstId="data.pst.id"
            @success="gdanTransferSuccess"
          />
        </div>
        <hr
          style="
            background-color: gray;
            height: 1px;
            border: none;
            margin: 0 5px;
          "
        />
        <div class="d-flex jc-center mt-2">
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="gdanTransfer"
            >确定</mt-button
          >
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="pstTransfer.popupVisible = false"
            >取消</mt-button
          >
        </div>
        <div style="height: 10px"></div>
      </div>
    </mt-popup>
    <!-- 工单答复审核 -->
    <mt-popup
      :closeOnClickModal="false"
      v-model="replayAudit.popupVisible"
      position="bottom"
      style="width: 100%"
    >
      <div>
        <mt-header title="答复审核">
          <mt-button slot="right" @click="replayAudit.popupVisible = false">
            <img slot="icon" src="@/assets/close.png" width="24" height="24" />
          </mt-button>
        </mt-header>
        <div>
          <gdanreplyaudit
            ref="gdanreplyaudit"
            :pstId="data.pst.id"
            @success="gdanReplayAuditSuccess"
          />
        </div>
        <hr
          style="
            background-color: gray;
            height: 1px;
            border: none;
            margin: 0 5px;
          "
        />
        <div class="d-flex jc-center mt-2">
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="gdanreplayaudit"
            >确定</mt-button
          >
          <mt-button
            size="small"
            class="ml-2"
            plain
            type="default"
            @click="replayAudit.popupVisible = false"
            >取消</mt-button
          >
        </div>
        <div style="height: 10px"></div>
      </div>
    </mt-popup>
  </div>
</template>

<script>
import upload from "../../../components/Contents.vue";
import gdanaudit from "../../../components/GDanAudit.vue";
import gdantransfer from "../../../components/GDanTransfer.vue";
import gdanreplyaudit from "../../../components/GDanReplyAudit.vue";
import ScrollBody from "@/components/ScrollBody.vue";
export default {
  components: {
    ScrollBody,
    upload,
    gdanaudit,
    gdantransfer,
    gdanreplyaudit,
  },
  created() {
    this.data.pst.id = this.$route.params.id;
    if (this.data.pst.id) {
      //读取舆情信息
      this.getPst();
    }
  },
  data() {
    return {
      bodyStyle: {
        overflowY: "auto",
        overflowX: "hidden",
        listStyle: "none",
        height: 420 + "px",
      },
      tabPosition: "top",
      transferBtnCaption: "",
      //数据项
      data: {
        statusName: "",
        pstTypeName: "",
        pst: {
          id: "",
        },
        nodes: [],
        negativeNode: "",
        replyNode: "",
      },
      deletePopup: {
        actions: [{ name: "确定", method: this.deletePst }],
        popupVisible: false,
      },
      actionSheet: {
        actions: [],
        sheetVisible: false,
      },
      //工单审查
      pstAudit: {
        popupVisible: false,
      },
      //工单审查
      pstTransfer: {
        popupVisible: false,
      },
      //答复审核
      replayAudit: {
        popupVisible: false,
      },
    };
  },
  methods: {
    resize(height) {
      this.bodyStyle.height = height - 10 + "px";
    },
    //取指定节点
    getNode(nodes, status) {
      for (var i = nodes.length - 1; i >= 0; i--) {
        var node = nodes[i];
        if (node.status == status) {
          return node;
        }
      }
      return "";
    },
    //读取舆情信息
    getPst() {
      let pstId = this.data.pst.id;
      this.pstApi
        .getPstInfo(pstId)
        .then((res) => {
          var data = res.data;
          data.pstContent = data.pstContent.replace(/&ldquo;/g, "“");
          data.pstContent = data.pstContent.replace(/&rdquo;/g, "”");
          this.data.pst = data;
          //
          this.actionSheet.actions = [];
          this.actionSheet.actions.push({
            name: "浏览来源地址",
            method: this.browser,
          });
          //取负面节点
          this.data.negativeNode = this.getNode(data.nodeInfos, -2);
          //取答复审核节点
          this.data.replyNode = this.getNode(data.nodeInfos, 2);
          if (data.status == -2) {
            this.transferBtnCaption = "去审查";
            this.actionSheet.actions.push({
              name: this.transferBtnCaption,
              method: this.toTansfer,
            });
          } else if (data.status == 0 || data.status == 3) {
            this.transferBtnCaption = "工单转办";
            this.actionSheet.actions.push({
              name: this.transferBtnCaption,
              method: this.toTansfer,
            });
          } else if (data.status == 2) {
            this.transferBtnCaption = "答复审核";
            this.actionSheet.actions.push({
              name: this.transferBtnCaption,
              method: this.toTansfer,
            });
          }
          this.data.statusName = this.pstApi.getStatusTransferTitle(
            data.status
          );
          this.data.pstTypeName = this.pstApi.getPstTypeName(data.pstType);
          this.data.nodes = data.nodeInfos;
        })
        .catch((err) => {
          this.$message.error("读取失败");
        });
    },
    deletePst() {
      this.deletePopup.popupVisible = false;
      let pstId = this.data.pst.id;
      this.pstApi
        .deletePst(pstId)
        .then((res) => {
          this.$toast("删除成功");
          this.formReturn();
        })
        .catch((error) => {
          this.$toast(error.response.data.Message);
        });
    },
    formReturn() {
      this.$router.back();
    },
    browser() {
      window.open(this.data.pst.pstUrl, "_blank");
    },
    toTansfer() {
      if (this.data.pst.status == -2) {
        this.pstAudit.popupVisible = true;
      } else if (this.data.pst.status == 0 || this.data.pst.status == 3) {
        this.pstTransfer.popupVisible = true;
      } else if (this.data.pst.status == 2) {
        this.replayAudit.popupVisible = true;
      }
    },
    openDeletePicker() {
      this.deletePopup.popupVisible = true;
    },
    openPicker() {
      this.actionSheet.sheetVisible = true;
    },
    //工单审查
    gdanAudit() {
      this.$refs.gdanaudit.formSubmit(1);
    },
    gdanAuditSuccess() {
      this.pstAudit.popupVisible = false;
      this.getPst();
    },
    //工单转办
    gdanTransfer() {
      this.$refs.gdantranser.formSubmit(1);
    },
    gdanTransferSuccess() {
      this.pstTransfer.popupVisible = false;
      this.getPst();
    },
    //工单答复审核
    gdanreplayaudit() {
      this.$refs.gdanreplyaudit.formSubmit(1);
    },
    gdanReplayAuditSuccess() {
      this.replayAudit.popupVisible = false;
      this.getPst();
    },
  },
};
</script>
  
<style lang="less" scoped>
/deep/.mint-cell {
  min-height: 32px;
}
/deep/ .mint-cell-wrapper {
  font-size: 13px;
}
/deep/ .mint-field .mint-cell-title {
  width: 60px;
}
/deep/input:disabled {
  background-color: #fff;
}
/deep/textarea:disabled {
  background-color: #fff;
}
</style>